// zoomAndFade.js
import { gsap } from 'gsap'

export function zoomInElement (el, duration = 0.3) {
  gsap.killTweensOf(el)
  gsap.set(el, {
    y: 50,
    scale: 0.5,
    opacity: 0.7
  })

  gsap.to(el, {
    y: 0,
    scale: 1,
    opacity: 1,
    duration,
    ease: 'power4.out'
  })
}

export function zoomOutElement (el, duration = 0.1, onComplete) {
  gsap.to(el, {
    y: 50,
    scale: 0,
    opacity: 0,
    duration,
    ease: 'power4.in',
    onComplete
  })
}

export function fadeInUpElement (el, duration = 0.3) {
  gsap.killTweensOf(el)
  gsap.set(el, {
    y: 50,
    opacity: 0
  })

  gsap.to(el, {
    y: 0,
    opacity: 1,
    duration,
    ease: 'power2.out'
  })
}

export function fadeOutDownElement (el, duration = 0.2, onComplete) {
  gsap.killTweensOf(el)
  gsap.to(el, {
    y: 50,
    opacity: 0,
    duration,
    ease: 'power2.in',
    onComplete
  })
}

export function fadeInElement (el, duration = 0.3) {
  gsap.killTweensOf(el)
  gsap.set(el, {
    opacity: 0
  })

  gsap.to(el, {
    y: 0,
    opacity: 1,
    duration,
    ease: 'power2.out'
  })
}

export function fadeOutElement (el, duration = 0.2, onComplete) {
  gsap.killTweensOf(el)
  gsap.to(el, {
    opacity: 0,
    duration,
    ease: 'power2.in',
    onComplete
  })
}
